import { OwnerPortfolioQuery } from "../types/ownerPortfolio.types";

export function buildOwnerPortfolioParams(
  query: OwnerPortfolioQuery
): Record<string, string | number> {
  const params: Record<string, string | number> = {
    sort: query.sort,
    metrics_days: query.metricsDays,
  };

  if (query.situation) {
    params.situation = query.situation;
  }

  const condominium = query.condominium?.trim();
  if (condominium) {
    params.condominium = condominium;
  }

  return params;
}
